import { api } from '../../DefaultService';
import {
  IDvrAlarmEntriesConfigParams,
  IDvrAlarmEntryProps,
  IDvrChannelProps,
  IDvrChannelsConfigParams,
  IDvrDeviceCreateProps,
  IDvrDeviceFilterProps,
  IDvrDeviceProps,
  IDvrDeviceSimpleProps,
  IDvrDeviceUpdateParams,
} from './types';
import { IPaginationParams } from '../../types';

const ENDPOINT = 'v1/devices/dvr';

export const createDvrDeviceAsync = async (
  data: IDvrDeviceCreateProps,
): Promise<IDvrDeviceProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getDvrDeviceByIdAsync = async (
  id: number,
): Promise<IDvrDeviceProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllDvrDeviceByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: IDvrDeviceFilterProps,
): Promise<IDvrDeviceSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllDvrDeviceCountByLicenseAsync = async (
  filter: IDvrDeviceFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateDvrDeviceAsync = async ({
  id,
  data,
}: IDvrDeviceUpdateParams): Promise<IDvrDeviceProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteDvrDeviceAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const configDvrChannelsAsync = async ({
  id,
  data,
}: IDvrChannelsConfigParams): Promise<boolean> => {
  return await api
    .put(`${ENDPOINT}/${id}/config/channels`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getDvrChannelsAsync = async (
  id: number,
): Promise<IDvrChannelProps[]> => {
  return await api
    .get(`${ENDPOINT}/${id}/config/channels`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const configDvrAlarmEntriesAsync = async ({
  id,
  data,
}: IDvrAlarmEntriesConfigParams): Promise<boolean> => {
  return await api
    .put(`${ENDPOINT}/${id}/config/alarmEntries`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getDvrAlarmEntriesAsync = async (
  id: number,
): Promise<IDvrAlarmEntryProps[]> => {
  return await api
    .get(`${ENDPOINT}/${id}/config/alarmEntries`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
